import { EmptyState } from '../Kit/_index';
import { onFormatShort } from './_chartScale';

const BLOCK = 'LStudio__app_chart';

/*
    🔥 EMBUDO

    steps: [{ label, value, tone }]

    ⚠️ SE MUESTRAN DOS PORCENTAJES DISTINTOS

    El de conversión respecto del PASO ANTERIOR y el respecto del
    TOTAL. Son preguntas diferentes: "¿cuánto pierdo en este paso?" y
    "¿cuánto llega desde el principio?". Un embudo que muestra uno solo
    esconde justamente el paso donde se está perdiendo la gente.

    ⚠️ EL ANCHO ES PROPORCIONAL AL PRIMER PASO, NO AL ANTERIOR

    Si cada tramo se midiera contra el de arriba, un embudo con caídas
    parejas se vería recto y no se notaría ninguna pérdida.
*/

export const ChartFunnel = ({
    steps = [],   formatValue = onFormatShort,
    showRates = true,  emptyLabel = 'Sin datos para graficar',
    ariaLabel = 'Embudo de conversión',
}) => {

    if (!steps.length) return <EmptyState title={emptyLabel} size="sm" />;

    const CLEAN = steps.map((s) => ({ ...s, value: Number(s.value) || 0 }));

    const FIRST = CLEAN[0]?.value || 1;

    return (
        <div className={`${BLOCK}_funnel`} role="img" aria-label={ariaLabel}>
            {
                CLEAN.map((step, index) => {

                    const PREV = index > 0 ? CLEAN[index - 1].value : null;

                    const FROM_PREV = PREV ? Math.round((step.value / PREV) * 100) : 100;

                    const FROM_TOP = Math.round((step.value / FIRST) * 100);

                    const LOST = PREV ? PREV - step.value : 0;

                    return (
                        <div key={step.label ?? index} className={`${BLOCK}_funnel__step`}
                            data-tone={step.tone ?? 'accent'} >

                            <div className={`${BLOCK}_funnel__head`}>

                                <span className={`${BLOCK}_funnel__label`}>{step.label}</span>

                                <span className={`${BLOCK}_funnel__value`}>{formatValue(step.value)}</span>

                            </div>

                            <div className={`${BLOCK}_funnel__track`}>
                                <div className={`${BLOCK}_funnel__bar`}  style={{ width: `${Math.max(2, FROM_TOP)}%` }} />
                            </div>

                            {
                                showRates && (
                                    <div className={`${BLOCK}_funnel__rates`}>

                                        {
                                            index > 0 && (
                                                <span className={`${BLOCK}_funnel__rate`}
                                                    data-bad={FROM_PREV < 50} >
                                                    {FROM_PREV}% del paso anterior
                                                </span>
                                            )
                                        }

                                        <span className={`${BLOCK}_funnel__rate`}>
                                            {FROM_TOP}% del total
                                        </span>

                                        {
                                            LOST > 0 && (
                                                <span className={`${BLOCK}_funnel__lost`}>
                                                    −{formatValue(LOST)}
                                                </span>
                                            )
                                        }

                                    </div>
                                )
                            }

                        </div>
                    );
                })
            }
        </div>
    );
};
